export const TREATMENTS = [
  { id: "standard_23", label: "Standard 23%", rate: 23 },
  { id: "standard_9", label: "9%", rate: 9 },
  { id: "reduced_13_5", label: "Reduced 13.5%", rate: 13.5 },
  { id: "zero", label: "Zero rated", rate: 0 },
  { id: "no_vat", label: "No VAT", rate: 0 },
  { id: "eu_reverse_charge", label: "EU reverse charge", rate: 23 },
  { id: "custom", label: "Custom rate", rate: null },
];

export const NO_VAT_TREATMENTS = ["zero", "no_vat"];

export const money = (v) =>
  `€${Number(v || 0).toLocaleString("en-IE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const presetRate = (treatment) =>
  TREATMENTS.find((t) => t.id === treatment)?.rate ?? null;

export const effectiveRate = (treatment, ratePercent) => {
  const preset = presetRate(treatment);
  return preset === null ? Number(ratePercent) : preset;
};

/** Mirrors the server split exactly: vat = gross - gross/(1+rate/100). */
export const splitGross = (gross, treatment, ratePercent) => {
  const g = Number(gross);
  const rate = effectiveRate(treatment, ratePercent);
  if (!Number.isFinite(g) || g <= 0 || !Number.isFinite(rate)) return null;
  if (NO_VAT_TREATMENTS.includes(treatment)) return { net: g, vat: 0, gross: g };
  if (treatment === "eu_reverse_charge") {
    return { net: g, vat: Math.round(g * rate) / 100, gross: g, selfAccounted: true };
  }
  const vat = Math.round((g - g / (1 + rate / 100)) * 100) / 100;
  return { net: Math.round((g - vat) * 100) / 100, vat, gross: g };
};

export const rateError = (treatment, ratePercent) => {
  if (presetRate(treatment) !== null) return null;
  if (ratePercent === "" || ratePercent == null) return "Enter a VAT rate, e.g. 9 for 9%";
  const rate = Number(ratePercent);
  if (!Number.isFinite(rate)) return "The VAT rate must be a number, e.g. 9 for 9%";
  if (rate < 0 || rate > 100) return "The VAT rate must be between 0 and 100";
  if (Math.round(rate * 100) / 100 !== rate) return "At most 2 decimal places";
  return null;
};
